import { render } from "./usergroupRight.vue?vue&type=template&id=6db8b811&scoped=true"
import script from "./usergroupRight.vue?vue&type=script&lang=js"
export * from "./usergroupRight.vue?vue&type=script&lang=js"

import "./usergroupRight.vue?vue&type=style&index=0&id=6db8b811&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db8b811"]])

export default __exports__